import { Content } from '@metrika/ui-kit/carbon';
import { styled } from '@metrika/ui-kit/emotion';

export const FullPage = styled.div`
   background: ${({ theme }) => theme.colors.uiBackground};

   width: 100%;
   min-height: 100vh;

   display: flex;
   flex-direction: column;

   overflow-x: hidden;
`;

export const StyledContent = styled(Content)`
   position: relative;
   width: 100%;
   flex: 1;

   margin: 3rem 0 0 0;

   padding: 1rem;
   @media (min-width: ${({ theme }) => theme.mediaBreakpoints.md}) {
      padding: 2rem;
   }
`;

export const StyledContentSidebar = styled(StyledContent, { shouldForwardProp: (n) => n !== 'onlyWorkspaces' })<{
   onlyWorkspaces?: boolean;
}>`
   //fix v11 sidebar to be compatible with custom expanded state like v10
   margin-inline-start: unset !important;
   margin-block-start: 3rem !important;

   @media (min-width: ${({ theme }) => theme.mediaBreakpoints.lg}) {
      padding-left: ${({ onlyWorkspaces }) => (!onlyWorkspaces ? '18rem' : '2rem')};
   }
`;
